module.exports = __webpack_public_path__ + "img/hero-getting-started.870bee5a.png";